export default function ImageBlock({ data }) {
  const { url, alt, caption } = data || {};
  if (!url) return null;
  return (
    <section className="py-10 md:py-14">
      <figure className="max-w-5xl mx-auto px-6 md:px-8">
        <img
          src={url}
          alt={alt || ""}
          className="w-full h-auto rounded-2xl border"
          style={{ borderColor: "var(--wp-border)" }}
        />
        {caption && (
          <figcaption className="text-sm mt-3 text-center" style={{ color: "var(--wp-text-muted)" }}>
            {caption}
          </figcaption>
        )}
      </figure>
    </section>
  );
}
